module.exports = __webpack_public_path__ + "static/media/CardBG.3b4b40bc.png";